export const BASE = {
  name: 'engage-insights',
  path: '/organizations/:orgId/research',
};

export const USE_CURRENT_ORG = {
  name: 'engage-insights',
  path: '/research',
};

export const LIST = {
  name: 'engage-insights.list',
  path: `${BASE.path}/projects`,
};

export const TERMS = {
  name: 'engage-insights.terms',
  path: `${BASE.path}/terms`,
};

export const ACTIVATE = {
  name: 'engage-insights.activate',
  path: `${BASE.path}/activate`,
};
